import { Component, OnInit } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {

  myDate: String;
  currentDate = new Date();
  ResponseBody: any;
  isRequired: boolean = true
  public uploadedFileExt: String;
  public pdfBytes: String;
  isEditMode: boolean = false;
  nextBtnLabel: any = '';
  fileExt: '';
  InitialLoad: boolean;
  filesize: 0;
  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute) {

    this.myDate = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy HH:mm:ss a')
  }


  onSubmit() {
    if ($("#obaoform").valid()) {
      this.callSaveRequest();
    }
  }

  ngOnInit() {
    //added to access global variable

    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    this.callReadRequest();
    const flowId = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
    this.nextBtnLabel = flowId === '0' ? 'Submit to customer' : 'Next';
     this.InitialLoad = true;
  }

  onload() {
    const _this = this;
    $("#obaoform").validate({
      rules: {
        doc_upload: {
          //DCI: (24/07/2020) comment out to solve issues by peiyee
          // required: this.isRequired,
          required: this.InitialLoad == true ? true : false,
          extension: "jpg|jpeg|pdf",
          // maxsize: 5000000,// 5mb
          maxsize:
          {
            depends: function (element) {
              if (this.fileExt == 'pdf' &&  this.filesize > 5000000) {
                return true
              } else {
                return false
              }
            }

          }
          // pattern: "^[a-zA-Z0-9]+\.+(jpg|jpeg|pdf)$"
        }
      },
      messages: {
        doc_upload: {
          required: "Please select your document",
          extension: "Please select an image (.jpg or .jpeg) or PDF file only",
          maxsize: "File size must not exceed 5MB each."
        }
      },
      errorPlacement: function (error, element) {

        if (element.attr("name") == "doc_upload") {
          error.appendTo($("#doc_upload_error_container"));
        }
      },
      submitHandler: function (form) {
        // $("#btn-next").prop("disabled", true);
      }
    });

    $(document).change(function () {
      $("#obaoform").valid();
    })

    /*   DCI update (16th June 2020) : Add javascript for thumbnail image start*/
    function handleFileSelect(evt) {
      _this.connect.showLoader()
      if (evt.target.files.length > 0) {
      var file = evt.target.files;
      // Declare variable of the id of changed input files 
      var id = $(this).attr('id');
      var filename = file[0].name;
      var filesize = file[0].size;//check filesize
      var maxsize = 5000000;//5mb maxsize
      var ext = filename.split('.').pop();//get the last period with extension only
      this.fileExt = ext;
      this.filesize = filesize;
      // console.log('File extension detected:' + this.fileExt);
      //console.log("pop:" + ext);
      // ("Current file size:" + filesize + 'bytes');

      //  console.log(ext[1]);
      _this.uploadedFileExt = ext;
      // Declare the id of container to be replace it img source
      var upload_doc = 'thumbnail_doc';
      // Loop through the FileList and render image files as thumbnails.
      for (var i = 0, f; f = file[i]; i++) {
        var reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = (function (theFile) {
          return function (e) {
            // Render thumbnail.
            if ((ext.toLowerCase() == "pdf") && filesize < maxsize) {
              $('#' + upload_doc).attr('src', 'assets/images/PDF.png');
              $('#' + upload_doc).css({ "width": "120px", "max-width": "229px", "max-height": "200px" });
              $("#file_text").text("Re-upload");
              _this.pdfBytes = e.target.result;
               _this.connect.hideLoader()
              //console.log(_this.pdfBytes);
            }
            //  else if(((ext.toLowerCase()== "jpg") || (ext.toLowerCase()== "jpeg")) && filesize <= maxsize ){
            else if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg"))) {

              $.canvasResize(theFile, {
                width: 500,
                height: 0,
                crop: false,
                quality: 100,
                callback: function (data) {
                  var f = $.canvasResize('dataURLtoBlob', data);
                  // console.log("Resized file size:" + f.size + 'bytes');
                  $('#' + upload_doc).attr('src', data);
                  $('#' + upload_doc).css({ "width": "auto", "max-width": "229px", "max-height": "200px" });
                  $("#file_text").text("Re-upload");
                  _this.connect.hideLoader()
                }
                //console.log(e.target.result);
              });
            } else {
              $('#' + upload_doc).attr('src', '');
              $('#' + upload_doc).css("width", "0px");
              $("#file_text").text("Re-upload");
              _this.connect.hideLoader()
            }
          };

        })(f);
        // Read in the image file as a data URL.
        reader.readAsDataURL(f);
  
      }
      }else {
        _this.connect.hideLoader()
      }

    }
    document.getElementById('doc_upload').addEventListener('change', handleFileSelect, false);

    /*   DCI update (16th June 2020) : Add javascript for thumbnail image end*/
  }

  // (Begin) CJT 5Jun2020 to call connectRest Service Function
  async restConnect(data, reqID) {
    // this.connect.consoleLog("data value", data);
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    return ServResponse;
  }
  // (End) CJT 05Jun2020


  // (Begin) CJT 16Jun2020 to call Request R0070
  async callSaveRequest() {
    var CapturedDocumentValue;
    if (this.uploadedFileExt.toLowerCase() == 'pdf') {
      CapturedDocumentValue = this.pdfBytes;
    } else {
      CapturedDocumentValue = $('#thumbnail_doc').attr('src')
    }
    var data = {
      CapturedDocuments: [{
        Time: this.myDate,
        Type: "POA",
        Value: CapturedDocumentValue,
        ExtensionType: this.uploadedFileExt
      }]
    }

    var ServResponse = await this.restConnect(data, "S0070");
    if (ServResponse.Status == "Success") {
      // this.InitialLoad = false;
      var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
      if (ServiceHeader.Flow == '0') {
        //sessionStorage.Link = ServResponse['RetrievableEmailLink']
        this.router.navigate(['/sales-assisted-thank-you', { name: ServResponse['Name'] }]);
      } else {
        if (!this.isEditMode) {
          this.router.navigate(['/upload-nric']);
        } else {
          this.router.navigate(['/director-confirm']);
        }
      }
    }
    else {
      //  console.log("Server Response: " + ServResponse.Status);
    }
  }

  async callReadRequest() {
    let caseID = JSON.parse(sessionStorage.getItem('ServiceHeader')).CaseID;
    if (caseID) {
      var data = {};
      var ServResponse = await this.restConnect(data, "R0070");
      if (ServResponse.Status == "Success") {
      this.InitialLoad = false;
        this.ResponseBody = ServResponse;
        if (this.ResponseBody.CapturedDocuments[0]) {
          var fileSrc = this.ResponseBody.CapturedDocuments[0].Value;
          var fileExtension = this.ResponseBody.CapturedDocuments[0].ExtensionType
          this.uploadedFileExt = fileExtension
          if (fileExtension.toLowerCase() === 'pdf') {
            $('#thumbnail_doc').css({ "width": "120px", "max-width": "229px", "max-height": "200px" });
            $('#thumbnail_doc').attr('src', 'assets/images/PDF.png');
            this.pdfBytes = fileSrc;
          } else {
            $('#thumbnail_doc').css({ "width": "auto", "max-width": "229px", "max-height": "200px" });
            $('#thumbnail_doc').attr('src', fileSrc);
          }

          $("#file_text").text("Re-upload");
          this.isRequired = false
        }
      }
      else {
        // console.log("Server Response: " + ServResponse.Status);
      }

    }
    this.onload()
  }
  // (End) CJT 16Jun2020

  public disableForm() {
    return ($('#thumbnail_doc').attr('src') === '')
  }
}
